// Games split into 3 roomy PLAYGROUND zones (garden theme, no buildings).
// Ordering (playable-first) + slicing happens in MohallaGames using from/to.
export const AREAS = [
  { id: "P1", name: "Play Park", decor: "park", tag: "Aa ja, khelein!", from: 0, to: 7 },
  { id: "P2", name: "Bagicha", decor: "park", tag: "Garden Games", from: 7, to: 14 },
  { id: "P3", name: "Bada Maidan", decor: "park", tag: "Team Games", from: 14, to: 21 },
];

// Hand-placed SCATTER (not a rigid grid) — up to 7 signboards, spaced so they never overlap.
const SCATTER = [
  { x: 16, y: 32 }, { x: 39, y: 27 }, { x: 63, y: 33 }, { x: 87, y: 28 },
  { x: 27, y: 66 }, { x: 53, y: 71 }, { x: 79, y: 64 },
];

export const layoutPositions = (count) => SCATTER.slice(0, count);
